var render, staticRenderFns
import script from "./adsOrder.vue?vue&type=script&lang=js"
export * from "./adsOrder.vue?vue&type=script&lang=js"
import style0 from "./adsOrder.vue?vue&type=style&index=0&id=9b4c88c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4c88c8",
  null
  
)

export default component.exports